import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import Model from "~/models/_Model";
import Session from "./Session";
import Station from "./Station";
import Scannable from "./Scannable";
import { useDayjs } from '#dayjs';
const dayjs = useDayjs();
dayjs.extend(relativeTime);
dayjs.extend(utc);

export default class ScanLog extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/scanning";
  }

  // Set the resource route of the model
  resource() {
    return "scan-logs";
  }

  relations() {
    return {
      session: Session,
      station: Station,
      scannable: Scannable,
    };
  }

  get display_scan_at() {
    return dayjs(this.scan_at).local().format("ddd, DD MMM YYYY hh:mm:ss A");
  }

  get display_scan_at_date() {
    return dayjs(this.scan_at).local().format("DD MMM YYYY");
  }

  get display_scan_at_time() {
    return dayjs(this.scan_at).local().format("hh:mm:ss A");
  }

  get display_actual_scan_at() {
    return dayjs(this.actual_scan_at)
      .local()
      .format("ddd, DD MMM YYYY hh:mm:ss A");
  }

  get display_processed_at() {
    if (!this.processed_at) {
      return "";
    }
    return dayjs(this.processed_at)
      .local()
      .format("ddd, DD MMM YYYY hh:mm:ss A");
  }
}
